import React, { useEffect, useRef, useState } from 'react';
import { Outlet } from 'react-router-dom';

// style
import styled from 'styled-components';
import './Landing.css';

// components
import Home1 from '../components/Home1';
import Home2 from '../components/Home2';
import Home3 from '../components/Home3';
import Home4 from '../components/Home4';
import Home5 from '../components/Home5';
import Home6 from '../components/Home6';

// img
import { useRecoilState } from 'recoil';
import { userInfo } from '../atoms';
import LandingInvited from '../modal/LandingInvited';
import { device } from '../hooks/device';
import LeftTest from '../modal/ServicePlanLeftTest';
import customAxios from '../api/handler';
import PreTest from '../modal/LandingPreTest';
import useToast from '../hooks/useToast';
import getApi from '../api/getApi';
import { useTranslation } from 'react-i18next';

const Landing = ({ nav, setNav, setMyPageScroll, banneris }) => {
  const { t } = useTranslation();
  const [user, setUser] = useRecoilState(userInfo);

  // ref for scroll
  const top = useRef();
  const service = useRef();
  const technic = useRef();
  const how = useRef();
  const qna = useRef();

  const [inviteInfo, setInviteInfo] = useState();
  const showToast = useToast();
  const [yOffset, setYOffset] = useState();

  // modal
  const [leftTestModal, setLeftTestModal] = useState(false);
  const [preTestModal, setPreTestModal] = useState(false);
  const [inviteModal, setInviteModal] = useState(false);

  useEffect(() => {
    if (document.location.href.split('#')[1] === 'how_to_use_examinee') {
      how.current.scrollIntoView({ block: 'start' });
    }
  }, []);

  useEffect(() => {
    if (window.innerWidth < 1140) {
      if (banneris) {
        setYOffset(-108);
      } else {
        setYOffset(-60);
      }
    } else {
      if (banneris) {
        setYOffset(-115);
      } else {
        setYOffset(-75);
      }
    }
  }, [window.innerWidth, banneris]);

  const elementOne = document.getElementById('pageOne');
  const elementThree = document.getElementById('pageThree');
  const elementFour = document.getElementById('pageFour');
  const elementFive = document.getElementById('pageFive');
  const elementSix = document.getElementById('pageSix');

  let pageOne =
    elementOne?.getBoundingClientRect().top + window.pageYOffset + yOffset;
  let pageThree =
    elementThree?.getBoundingClientRect().top + window.pageYOffset + yOffset;
  let pageFour =
    elementFour?.getBoundingClientRect().top + window.pageYOffset + yOffset;
  let pageFive =
    elementFive?.getBoundingClientRect().top + window.pageYOffset + yOffset;
  let pageSix =
    elementSix?.getBoundingClientRect().top + window.pageYOffset + yOffset;

  useEffect(() => {
    if (nav[0] === 1) {
      if (nav[1] === '') {
        window.scrollTo({ top: pageOne, behavior: 'smooth' });
      } else {
        top.current.scrollIntoView({ block: 'end' });
      }
    } else if (nav[0] === 3) {
      if (nav[1] === '') {
        window.scrollTo({ top: pageThree, behavior: 'smooth' });
      } else {
        service.current.scrollIntoView({ block: 'start' });
      }
    } else if (nav[0] === 4) {
      if (nav[1] === '') {
        window.scrollTo({ top: pageFour, behavior: 'smooth' });
      } else {
        technic.current.scrollIntoView({ block: 'start' });
      }
    } else if (nav[0] === 5) {
      if (nav[1] === '') {
        window.scrollTo({ top: pageFive, behavior: 'smooth' });
      } else {
        how.current.scrollIntoView({ block: 'start' });
      }
    } else if (nav[0] === 7) {
      if (nav[1] === '') {
        window.scrollTo({ top: pageSix, behavior: 'smooth' });
      } else {
        qna.current.scrollIntoView({ block: 'start' });
      }
    }
    return setNav(1, '');
  }, [nav, setNav]);

  useEffect(() => {
    if (user?.hasInvite) {
      setInviteModal(true);
      getApi
        .getInvitedList()
        .then(({ data }) => {
          setInviteInfo(data);
        })
        .catch(({ response }) => {
          console.log(response);
        });
    }
  }, [user?.hasInvite]);

  /** 수락 전 미결제 금액과 현재 진행중인 시험 유무 확인 및 환불 금액 체크 */
  const beforeAccept = (props) => {
    getApi
      .getProgressingTest()
      .then(() => {
        customAxios
          .get(`/api/v1/users/pending-test`)
          .then(() => {
            inviteAnswer(props);
            setInviteModal(false);
          })
          .catch(({ response }) => {
            if (response.data.errorCode === 'ENTERPRISE-011') {
              setPreTestModal(true);
              setInviteModal(false);
            } else {
              showToast({
                message: t(`errorCode.unknown_server_error`),
              });
            }
          });
      })
      .catch(({ response }) => {
        if (
          response.data.errorCode === 'ENTERPRISE-010' ||
          response.data.errorCode === 'TIMEZONE-007'
        ) {
          setLeftTestModal(true);
          setInviteModal(false);
        } else {
          showToast({
            message: t(`errorCode.unknown_server_error`),
          });
        }
      });
  };

  const inviteAnswer = (props) => {
    console.log(props);
    customAxios
      .patch(`/api/v1/users/individual/approval`, {
        isVerifiedHostEmailInvite: props,
        hostEmail: inviteInfo?.invitedList?.hostEmail,
        hostGroupName: inviteInfo?.invitedList?.hostGroupName,
      })
      .then((data) => {
        console.log(data);
        setPreTestModal(false);
        customAxios
          .get(`/api/v1/hosts`)
          .then(({ data }) => {
            setUser(data?.getHost);
          })
          .then(() => {
            if (props === 'approval') {
              showToast({
                message: ` 
              ${t(`errorCode.transToMember1`)}${
                  inviteInfo?.invitedList?.hostGroupName
                }${t(`errorCode.transToMember2`)}`,
              });
            }
          })
          .catch(({ response }) => {
            showToast({ message: t(`errorCode.unknown_server_error`) });
          });
      })
      .catch(({ response }) => {
        console.log(response);
        if (
          response.data.errorCode === 'HOST-ROLE-003' ||
          response.data.errorCode === 'HOST-ROLE-005' ||
          response.data.errorCode === 'ENTERPRISE-006'
        ) {
          showToast({
            message: t(`errorCode.unknown_server_error`),
          });
        }
      });
  };

  return (
    <>
      {inviteModal && (
        <LandingInvited
          inviteInfo={inviteInfo}
          setInviteModal={setInviteModal}
          inviteAnswer={inviteAnswer}
          beforeAccept={beforeAccept}
        />
      )}
      {leftTestModal && (
        <LeftTest
          close={setLeftTestModal}
          title={t(`mypage.f1_2.title`)}
          textOne={t(`mypage.f1_2.body1`)}
          textTwo={t(`mypage.f1_2.body2`)}
        />
      )}
      {preTestModal && (
        <PreTest
          setPreTestModal={setPreTestModal}
          inviteAnswer={inviteAnswer}
        />
      )}
      <StBody>
        <StBack>
          <div ref={top} id="pageOne" />
          <Home1 id="pageOne" />
          <Home2 />
          <div ref={service} id="pageThree" />
          <Home3 id="pageThree" />
          <div ref={technic} id="pageFour" />
          <Home4 />
          <div ref={how} id="pageFive" />
          <Home5 />
          <div ref={qna} id="pageSix" />
          <Home6 setMyPageScroll={setMyPageScroll} id="pageSix" />
        </StBack>
      </StBody>
      {/* <Outlet /> */}
    </>
  );
};

const StBody = styled.div`
  @media ${device.pc} {
    /* min-width: 1440px; */
    min-width: 1440px;
  }
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  /* overflow: hidden; */
`;

const StBack = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  position: relative;
`;
export default Landing;
